export const BookingOptionTypes = Object.freeze({
  PHONE: 'PHONE',
  VISIT_SHOP: 'VISIT_SHOP',
  BEAUTY_SOC: 'BEAUTY_SOC',
});
